// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2JB1W","header":"ClearentDisclaimer_header__2DosW","inner":"ClearentDisclaimer_inner__27VGj"};